import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {

  transform(value: string): string {
    const date = new Date(value);
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    // Check if the date is today
    const isToday = date.toDateString() === today.toDateString();

    // Check if the date is tomorrow
    const isTomorrow = date.toDateString() === tomorrow.toDateString();

    // Format the time as "HH:MM AM/PM"
    const datePipe = new DatePipe('en-US');
    const formattedTime = datePipe.transform(date, 'hh:mm a');

    if (isToday) {
      return `Today ${formattedTime}`;
    } else if (isTomorrow) {
      return `Tomorrow ${formattedTime}`;
    } else {
      // Format the date as "MMM dd, yyyy HH:MM AM/PM"
      const formattedDate = datePipe.transform(date, 'MMM dd, yyyy hh:mm a');
      return formattedDate;
    }
  }
}
